import React, {
  useEffect, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import {
  setRepeatableSectionCount,
} from '@redux/modules/listing';
import { selectPhotoMetaCollection } from '@redux/selectors/PhotoSelector';
import { clearPhotoCollection } from '@redux/modules/photo';
import 'cropperjs/dist/cropper.css';
import ImageDropZone from './imageDropZone/ImageDropZone';
import ImageCropperModal from './imageCropperModal/ImageCropperModal';

const ImageCropper = ({ fields, photosPayload }) => {
  const dispatch = useDispatch();
  const { values, setValues } = useFormikContext();
  const photoCollection = useSelector(selectPhotoMetaCollection);

  // clears photo collection on unmount; note the nested anonymous function
  useEffect(() => () => {
    dispatch(clearPhotoCollection());
  }, []);

  const transformFields = currentFields => {
    const newFields = [];
    if (currentFields?.fields) {
      currentFields[0].fields.forEach(field => { newFields[field.FieldName] = ''; });
    }
    return newFields;
  };

  const fieldNames = useMemo(() => transformFields(fields), [fields]);

  // object structure to write to formik values.Photos
  const createFormikEntry = photoMeta => {
    const formikEntry = {
      key: photoMeta.key,
      id: photoMeta.id,
      URL: photoMeta.externalURL,
      UniqueID: photoMeta.flexMeta.UniqueID ?? null,
      ParentID: photoMeta.flexMeta.ParentID ?? null,
      PreferredPhotoYN: photoMeta.flexMeta.PreferredPhotoYN ?? null,
      ResourceName: photoMeta.flexMeta.ResourceName ?? null,
      SortOrder: photoMeta.SortOrder,
      IsDeleted: photoMeta.IsDeleted,
      IsLive: photoMeta.flexMeta.IsLive ?? null,
      IsPreload: photoMeta.flexMeta.IsPreload ?? null,
      Description: photoMeta.Description,
      MediaType: photoMeta.flexMeta.MediaType ?? null,
      MediaCategory: photoMeta.flexMeta.MediaCategory ?? null,
    };
    return formikEntry;
  };

  // writes redux photo collection to formik.
  useEffect(() => {
    if (photoCollection) {
      let formikPhotos = values?.Photos ?? {};
      if (photoCollection.length === 0) formikPhotos = {};
      photoCollection.forEach(dPhoto => {
        const formikEntry = createFormikEntry(dPhoto);
        if (formikPhotos?.[formikEntry.key] && formikPhotos?.[formikEntry.key] !== formikEntry) {
          formikPhotos[formikEntry.key] = { ...fieldNames, ...formikEntry };
        } else if (!formikPhotos?.[formikEntry.key]) formikPhotos[formikEntry.key] = formikEntry;
      });
      const formikValues = values;
      formikValues.Photos = formikPhotos;
      setValues(formikValues);
      dispatch(setRepeatableSectionCount(formikValues));
    }
  }, [photoCollection]);

  return (
    <>
      <ImageDropZone photosPayload={photosPayload} />
      <ImageCropperModal />
    </>
  );
};

ImageCropper.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape()),
  photosPayload: PropTypes.arrayOf(PropTypes.shape()),
};

export default ImageCropper;
